/*
 * @Author: jackeyGuo
 * @Date: 2025-01-22 14:14:14
 * @LastEditors: jackeyGuo
 * @LastEditTime: 2025-03-31 18:07:40
 */
const compileConfig = {
  LOCAL: {
    publicPath: "https://localhost:8080/",// 原本设置为空，但是本地环境，csr-components被igws-fe引用的时候，会导致一些iconfont资源路径不对
    workspaceDomain: "https://heyf156-c1-30894-8080.devops.midea.com/",
  },
  DEV: {
    publicPath: `https://cdnjs-cn-uat.midea.com/dev-aem-fe/csr-components/dist/`,
  },
  SIT: {
    publicPath: `https://cdnjs-cn-uat.midea.com/sit-aem-fe/csr-components/dist/`,
  },
  UAT: {
    publicPath: `https://cdnjs-uat.midea.com/aem-fe/csr-components/dist/`,
  },
  PROD: {
    publicPath: `https://cdnjs.midea.com/aem-fe/csr-components/dist/`,
  },
};

const brandConfig = {
  "midea":{
      LOCAL: {
        mcLoginSdk:'https://signinuat.midea.com/sdk/Login.umd.min.js',
        b2bCaptchaId:"a38bf44bbbfb193ea7c06f959c53eb02", //接入极验的配置参数
        shopifyCaptchaId:"1d4a95789776fed1e23f4a9b7ffb438d", //接入极验的配置参数
      },
      DEV: {
        mcLoginSdk:'https://signinuat.midea.com/sdk/Login.umd.min.js',
        b2bCaptchaId:"a38bf44bbbfb193ea7c06f959c53eb02",
        shopifyCaptchaId:"1d4a95789776fed1e23f4a9b7ffb438d", //接入极验的配置参数
      },
      SIT: {
        mcLoginSdk:'https://signinuat.midea.com/sdk/Login.umd.min.js',
        b2bCaptchaId:"a38bf44bbbfb193ea7c06f959c53eb02",//接入极验的配置参数
        shopifyCaptchaId:"1d4a95789776fed1e23f4a9b7ffb438d", //接入极验的配置参数
      },
      UAT: {
        mcLoginSdk:'https://signinuat.midea.com/sdk/Login.umd.min.js',
        b2bCaptchaId:"a38bf44bbbfb193ea7c06f959c53eb02",
        shopifyCaptchaId:"1d4a95789776fed1e23f4a9b7ffb438d", //接入极验的配置参数
      },
      PROD: {
         mcLoginSdk:'https://signin.midea.com/sdk/Login.umd.min.js',
         b2bCaptchaId:"0a57b906bbdfe76e0f3543eb11f8d3fd",
         shopifyCaptchaId:"fb5eae4c49fe0b87dac27f5bd8200402",
      },
  },
   "toshiba":{
      LOCAL: {
        mcLoginSdk:'https://signinuat.midea.com/sdk/Login.umd.min.js',
        b2bCaptchaId:"2c966f323ed10223cc34e7c2fa5295e0", //接入极验的配置参数2c966f323ed10223cc34e7c2fa5295e0
        shopifyCaptchaId:"bac8d1e70b85f5fff0ba752f8a50cbfa", //接入极验的配置参数
      },
      DEV: {
        mcLoginSdk:'https://signinuat.midea.com/sdk/Login.umd.min.js',
        b2bCaptchaId:"2c966f323ed10223cc34e7c2fa5295e0",
        shopifyCaptchaId:"bac8d1e70b85f5fff0ba752f8a50cbfa", //接入极验的配置参数
      },
      SIT: {
        mcLoginSdk:'https://signinuat.midea.com/sdk/Login.umd.min.js',
        b2bCaptchaId:"2c966f323ed10223cc34e7c2fa5295e0",//接入极验的配置参数
        shopifyCaptchaId:"bac8d1e70b85f5fff0ba752f8a50cbfa", //接入极验的配置参数
      },
      UAT: {
        mcLoginSdk:'https://signinuat.midea.com/sdk/Login.umd.min.js',
        b2bCaptchaId:"2c966f323ed10223cc34e7c2fa5295e0",
        shopifyCaptchaId:"bac8d1e70b85f5fff0ba752f8a50cbfa", //接入极验的配置参数
      },
      PROD: {
         mcLoginSdk:'https://signin.midea.com/sdk/Login.umd.min.js',
         b2bCaptchaId:"284bee4132233921ecba61114d3f3306",
         shopifyCaptchaId:"dab19d34527d90e41e5c8b232d8f90e3",
      },
  }

}

module.exports = {
    brandConfig,
    compileConfig,
};
